const messages = {
    fr: {
        message: {
            yes: "oui",
            no: "non",

            see_all_references: "Voir toutes les références",

            home: "Home",
            agency: "Agence",
            refs: "Refs",
            technos: "Technos",
            harkhan: "Formavisa",
            lab: "Lab",
            contact: "Contact",
            see_more: "En voir +",
            our_clients: "Nos clients",

            our_news: "Explorez nos actualités",

            title_contact: "CONTACTEZ-NOUS !",
            btn_devis: "Obtenir un devis détaillé",
            contact_content1: "Vous avez un projet, parlons-en !",
            contact_content2: "Nous pouvons SÛREMENT VOUS AIDER…",
            contact_address: "SARL au capital de 200 000 € - SIRET : 48507196300030 - NAF : 5829C",

            title_our_offer: "NOTRE OFFRE 100% SUR MESURE",

            title_our_offer_1: "Conseil et pilotage de vos projets L&D",
            title_our_offer_2: "Formations digitales et Serious games",
            title_our_offer_3: "Innovation",
            title_our_offer_4: "Vidéos",
            title_our_offer_5: "Développements",
            title_our_offer_6: "Evaluation et LMS sur mesure",

            desc_our_offer_1: "Définition de votre stratégie de formation.<br />Conseil pédagogique et technologique.<br />Ingénierie de formation.",
            desc_our_offer_2: "Jeux immersifs, escape games, storytelling.<br />Storyline 360, RISE, MOOCS, micro-learning.<br />Modules sur smartphone. SCORM, xAPI.",
            desc_our_offer_3: "Approches originales, résultats inédits.<br />Solutions IA, adaptive learning, modules collaboratifs, ancrage mémoriel, …",
            desc_our_offer_4: "Films et reportages interactifs, interviews.<br />Motion design, animations narratives.<br />Teasers.",
            desc_our_offer_5: "Web, applications mobiles.<br />PHP, HTML/JS, React Native.<br />Solutions d'intégration IA.",
            desc_our_offer_6: "Evaluation des connaissances et des compétences, déploiement des formations, gestion des habilitations.",

            btn_our_offer_1: "Comprendre nos métiers",
            btn_our_offer_2: "Explorer nos références",
            btn_our_offer_3: "Visiter le LAB",
            btn_our_offer_4: "Regarder des exemples",
            btn_our_offer_5: "En savoir +",
            btn_our_offer_6: "Découvrir notre solution",

            required_fields: "* Champ obligatoire.",

            your_name_paceholder: "Votre nom*",
            your_name: "Votre nom",
            your_email_placeholder: "Votre email*",
            your_email: "Votre email",
            your_tel: "Votre tel",
            your_request: "Votre demande, vos projets",
            see: "Voir",

            project_focus_1: "Hot trend",
            intro_project_focus_1: "Pour Yookan, haikara développe des bornes d'arcade pour faire découvrir des métiers en jouant&nbsp;!",

            project_focus_2: "Focus projet",
            intro_project_focus_2: "Pour Saint-Gobain, haikara à développé un Serious Game sur l'innovation... Disruptif&nbsp;!",

            project_focus_3: "En direct du lab",
            intro_project_focus_3: "Ajouter des intéractions inédites dans Storyline&nbsp;? C'est possible : un exemple à tester ici&nbsp;!",

            project_focus_4: "Focus projet",
            intro_project_focus_4: "Avec The Great Challenge, haikara a créé un Serious Game de mémorisation inédit&nbsp;!",

            project_focus_5: "Vidéo",
            intro_project_focus_5: "A Story of Glass, c'est toute l'histoire du verre de l'antiquité à nos jours ! Une vidéo riche d'enseignement&nbsp;!",

            project_focus_6: "Hot trend",
            intro_project_focus_6: "Quaistion pour un champion&nbsp;! Avec l'IA, haikara lance un service de génération de quiz gratuit&nbsp;!",

            project_focus_7: "La compil",
            intro_project_focus_7: "Quels personnages choisir pour incarner vos formations digitales ? Petit panorama en vidéo&nbsp;!",

            to_post: "Envoyer",
            msg_footer: "Belle journée !",
            send_mail_ok: "Votre message a été envoyé avec succès",
            send_mail_ko: "Une erreur s'est produite veuillez réessayer ultérieurement",
            filter_metier: "#METIER",
            filter_sujet: "#SUJET",
            filter_dispositif: "#DISPOSITIF",

            our_mission: "Notre mission",
            our_mission_desc: "Vous accompagner dans votre stratégie Learning & Developpement en réalisant sur-mesure vos formations digitales :<br />efficaces, mémorables et parfaitement adaptées à vos objectifs.",
            other_refs: "Autres sujets pouvant vous intéresser",

            other_extra: "Autres sujets pouvant vous intéresser",
            other_functionality: "Autres fonctionnalités pouvant vous intéresser",

            error_has_occurred: "Une erreur s'est produite",
            play: "Jouer",
            restart: "Rejouer",
            send: "Envoyer",
            game_intro1: "Qui suis-je ?",
            game_intro2: "Quel personnage historique se cache derrière cette description générée par ia ?",
            game_pseudo: "Entrez votre nom ou pseudo",
            game_validate: "Valider",

            devis_intro1: "Vous souhaitez obtenir un devis pour la réalisation de votre formation digitale sur-mesure ?",
            devis_intro2: "<p class='bold'>Oui, j'ai besoin d'un prix, mais je n'ai pas le temps de rédiger un cahier des charges !</p><p>Ce formulaire est fait pour vous. Il nous permettra de recueillir vos attentes avec suffisamment de précision pour vous poster une première offre.</p>",
            devis_intro3:
                "<p class='bold'>Quoi ? Pourquoi devrais-je remplir un formulaire aussi long ?</p><p>Et bien il y a des métriques sans lesquels on peut difficilement vous donner un prix, comme la durée de la formation, le nombre de langues, ou savoir s'il faut enregistrer des voix… Il y a d'autres choses qui nous aident, mais vous n'êtes pas obligé de tout remplir !</p>",
            devis_intro4:
                "<p class='bold'>Ok, mais je n'ai vraiment pas envie de remplir un formulaire…</p><p>Nous comprenons. Dans ce cas, on peut aussi en discuter par téléphone ou en visio ! Laissez-vous un message sur <a href='#' class='lk-contact'>la page contact</a>, avec vos coordonnées et l'objet de votre demande, et nous vous rappellerons dans les meilleurs délais.</p>",
            devis_info_required: "signifie que le champ est obligatoire",

            devis_label_name: "Votre nom",
            devis_label_email: "Votre e-mail",
            devis_label_tel: "Votre téléphone",

            devis_project: "Parlons un peu de votre projet",

            devis_label_title: "Titre ou sujet de la formation",
            devis_label_duration: "Durée de la formation pour l'utilisateur (en minutes)",
            devis_label_objective: "Objectifs de la formation",
            devis_label_target: "Public cible (profil, âge, connaissance de l'outil informatique, habitude du elearning, etc.)",
            devis_label_modality: "Modalité envisagée (Ex. : module linéaire, non linéaire, découpé en micro learning, gamifié, etc.)",
            devis_label_number_people_targeted: "Nombre de personnes visées",
            devis_label_delivery_method: "Mode(s) de diffusion",
            devis_label_launch_date: "Date de lancement de votre formation",
            devis_label_number_of_modules: "Si la formation contient plusieurs modules, vous pouvez préciser",

            devis_languages_and_sounds: "Langages et sons",

            devis_language_fr: "Français",
            devis_language_en: "Anglais",
            devis_language_other: "Autres",

            devis_label_init_lang: "Langue initiale (module modèle)",
            devis_label_additional_lang: "Merci d'indiquer le nombre de langues supplémentaires",
            devis_label_voiceover: "Voix off et sous-titres",
            devis_label_video: "La formation contient-elle de la vidéo fournie ou à réaliser ?",
            devis_label_needs_video: "Merci de préciser les besoins (tournage, montage, intégration)",

            devis_file: "Un document utile à nous envoyer ?",

            devis_label_file_intro: "Documents utiles pour le devis (appel d'offre, cahier des charges, etc.). Merci de zipper les fichiers s'il y en a plusieurs.<br />Vous pouvez poster un seul fichier, en word, PPT ou PDF, de 10 Mo maximum.",
            devis_label_file_btn: "Choisir un fichier",
            devis_label_file_result: "Aucun fichier choisi",

            devis_technical: "Parlons un peu technique (ou pas 🙂 )",

            devis_label_technical: "Technologie du projet (si souhaitée) ou précisions (version SCORM, mode de complétion, Quiz avec Score validant ?)",
            devis_label_supports: "Supports informatiques de diffusion (PC, tablettes, smartphones ?)",
            devis_label_browsers: "Navigateurs Internet cibles (Chrome, Edge, Firefox... tous ?)",
            devis_label_others: "Autres précisions utiles",

            devis_production: "Quel genre de production cherchez-vous ?",

            devis_production_opt1: "Niveau 1 : formation linéaire simple",
            devis_production_opt2: "Niveau 2 : formation scénarisée et enrichie",
            devis_production_opt3: "Niveau 3 : serious game ou équivalent",

            devis_label_level: "Niveau de réalisation attendu",
            devis_label_accessibility: "Accessibilité des contenus",

            devis_accessibility_opt1: "Standard (sous-titres pour les projets sonorisés)",
            devis_accessibility_opt2: "Enrichie (navigation au clavier, adapté aux personnes non voyantes,....)",

            devis_label_specific_remarks: "Remarques spécifiques",

            devis_option: "Tout ce qui est suit est bon à savoir, mais c'est... facultatif !",

            devis_label_atmosphere: "Quel type d'ambiance cherchez vous ? (chaleureux, professionnel, humoristique, corporate, décalé...)",
            devis_label_graphical_environment: "Avez-vous un environnement graphique préféré ? (vidéo, photos, illustrations, 3D, style de dessin, utilisation de personnages ou non, etc.)",
            devis_label_remark: "Une dernière chose à ajouter ?",

            devis_btn: "Envoyer",

            more_ref: "Découvrir toutes nos références&nbsp;!",

            msg_loader: "<span>haikara</span> vous propose une expérience web sans soucis et sans cookies.",

            fv: {
                banner_1: "Une démo ?",
                banner_2: "Nous contacter",
                banner: "EVALUER ET PILOTER EFFICACEMENT L'ÉVOLUTION<br />DES CONNAISSANCES DE VOS ÉQUIPES",
                line_1: {
                    text_1: "ÉVALUATION",
                    text_2: "FORMATIVES",
                    text_3: "DIAGNOSTIQUES",
                    text_4: "CERTIFIANTES",
                    text_5: "Déployez aisément vos sessions d'évaluation auprès de vos équipes",
                    text_6: "Gardez le contrôle grâce à un suivi exhaustif et facile à prendre en main.",
                    text_7: "Pilotez les besoins de formation en suivant précisément l'évolution des connaissances dans le temps.",
                    text_8: "CRÉEZ FACILEMENT VOS ÉVALUATIONS",
                },
                line_2: {
                    text_1: "HABILITATION",
                    text_2: "PILOTEZ LES HABILITATIONS DE VOS ÉQUIPES.",
                    text_3: "Traçabilité exhaustive des évaluations de vos collaborateurs",
                    text_4: "Réponse aux obligations réglementaires les plus exigeantes",
                    text_5: "Accessibilité des résultats en quelques clics en cas d'audit.",
                    text_6: "UNE SOLUTION ADAPTÉE<br />AUX SECTEURS LES PLUS EXIGEANTS",
                    text_7: "Santé, Pharma, Aéronautique, Industrie, Médical, Bâtiment, Télécom...<br />FormaVisa a été certifiée Pharma dans le cadre de l'usage d'un de ses clients.",
                },
                line_3: {
                    text_1: "ILS NOUS FONT CONFIANCE",
                    text_2: "UNE PLATEFORME INNOVANTE, PENSÉE POUR VOUS, AVEC VOUS",
                    text_3: "Depuis 2005, nos années d'innovation constante au service de tous les secteurs d'activités<br />nous ont permis de construire une solution qui répond à vos besoins les plus spécifiques<br />en matière d'évaluation et d'habilitation.",
                },
                line_4: {
                    text_1: "PUISSANCE ≠ COMPLEXITÉ",
                    text_2: "DE NOMBREUSES FONCTIONNALITÉS À PORTÉE DE CLIC FACILES À PRENDRE EN MAIN !",
                    text_3: "Gérez simplement<br />votre base<br />de questions",
                    text_4: "Paramétrage<br />et automatisation<br />des évaluations",
                    text_5: "Générez des questions<br />avec l'IA",
                    text_6: "Outil statistique<br />poussé",
                },
                line_5: {
                    text_1: "ET CE N'EST PAS TOUT !",
                    text_2: "FORMAVISA EST UNE SOLUTION ADAPTATIVE OUVERTE<br />À L'AJOUT DE RESSOURCES  PÉDAGOGIQUES DE TOUT TYPE<br />ET COMPATIBLE SCORM.",
                    text_3: "Ajoutez des contenus pédagogiques, des formations en ligne et d'autres ressources (PPT, PDF, DOC, etc.) ou vidéo et montez des parcours complets en complément de vos évaluations.",
                    text_4: "Associez les conditions de progression dans le parcours à la complétion d'objectifs, ou mettez automatiquement à disposition des contenus pédagogiques en cas d'échec de certification, consultables avant le rattrapage.",
                    text_5: "Observez les résultats et tracez le bon suivi des contenus pour répondre à vos obligations de formation à l'aide de nos outils de suivi statistiques.",
                },
                line_6: {
                    text_1: "LES EXTRAS",
                    text_2: "UNE DÉMO ?",
                    title_1: "CONCEPTION DE VOS ÉVALUATIONS",
                    content_1: "Confiez-nous vos projets !",
                    btn_1: "HAIKARA VOUS ACCOMPAGNE",
                    title_2: "COMPATIBILITÉ ELEARNING",
                    content_2: "Exploitez vos formations digitales !!",
                    btn_2: "DES SESSIONS MULTI-FORMATS",
                    title_3: "PERSONNALISATION ET ÉVOLUTIVITÉ",
                    content_3: "Chez haikara notre ADN c'est le sur-mesure.",
                    btn_3: "VOTRE FORMAVISA",
                },
            },

            games: {
                who_is_it: {
                    btn_play: "Jouer !",
                    content_1: "Jouons avec<br />l'intelligence<br />artificielle !",
                    content_2: '<span class="bold">Dialoguez avec notre IA</span><br />pour essayer de trouver<br />un personnage historique.<br /><span class="bold">Posez-lui autant de questions<br />que vous voulez</span> pour y parvenir.',
                    content_3: "Vous pouvez également donner votre langue<br />au Tchat pour découvrir la réponse.",
                    give_me_the_answer: "Donner ma langue au chat",
                },
            },

            page_agency: {
                card_01: {
                    title: "<span>CONSEIL</span> <span>ET CONCEPTION</span>",
                    list: "<li>Définition de la stratégie digitale de formation et d'évaluation.</li><li>Analyse des objectifs et des besoins.</li><li>Rédaction des supports pédagogiques.</li>",
                    link: "En savoir +  sur nos fondamentaux",
                },
                card_02: {
                    title: "<span>RÉALISATION</span> <span>SUR-MESURE</span>",
                    list: "<li>Conception et réalisation graphique (2D, 3D, illustration, vidéo…).</li><li>Intégration de médias (Storyline, Rise…).</li><li>Développement informatique.</li><li>Contenus SCORM 1.2, 2004. xAPI.</li>",
                    link: "Voir nos références",
                },
                card_03: {
                    title: "<span>DIFFUSION</span> <span>ET ÉVALUATION</span>",
                    list: "<li>Location de notre plateforme FormaVisa en mode SaaS.</li><li>Diffusion de contenus de formation (LMS, LXP).</li><li>Évaluation des connaissances et des compétences.</li>",
                    link: "Voir la page dédiée",
                },

                intro: '<span class="span_1">DEPUIS 2005</span>, <span class="span_2">HAIKARA</span> CONÇOIT ET PRODUIT DES <span class="span_1">DISPOSITIFS DIGITAUX</span> DE FORMATION <span class="span_1">ORIGINAUX</span> ET <span class="span_1">MÉMORABLES</span>.',

                block_1: {
                    title: "haikara réunit l'ensemble des compétences nécessaires à la mise en œuvre de vos programmes de formation e-learning.",
                    content: `<p>Le travail en équipe, la coordination et la communication entre les différents intervenants, ainsi que la fluidité de la production, sont les fondements qui garantissent le respect des délais 
                            dans une exigence constante de qualité.</p>
                            <p>Nous vous accompagnons dans toutes les étapes de la mise en place d'une formation e-learning : choix du dispositif, définition du programme de formation, réalisation, actions 
                            de communication et d'incentive.</p>`,
                },
                block_2: {
                    title: "Nous apportons conseil et expertise pour concevoir les supports répondant aux besoins de formation et d'évaluation des entreprises.",
                    content: `<p>Nos productions sont scénarisées et médiatisées afin de favoriser l'immersion 
                            et la motivation des apprenants avec pour objectif et faciliter l'apprentissage 
                            et de développer leurs compétences.</p>`,
                },
                block_3: {
                    title: "Nous intervenons dans toutes les phases de vos projets.",
                    content: `<p>Choix des dispositifs de formation, conception 
                                et production des supports, mise en place 
                                de notre solution d'évaluation et de certification,
                                déploiement sur LMS, et plan de communication.</p>`,
                },
            },

            share_this_reference: "Partager cette référence",
            link_copied: "Lien copié !",
            copy_link: "Copier le lien",
            share_close: "Fermer",

            footer_cookie: "Notre site ne traite aucune donnée personnelle. <span class='clickable-cookie' data-action='cookie-more'>En savoir plus</span> sur notre politique intraitable en matière de protection de votre vie privée.",
            content_cookie: `<p>Nous utilisons <strong>Google Analytics 4</strong> uniquement à des fins de mesure d'audience sur notre site, sans collecte de données personnelles identifiables.</p>
                            <ul>
                            <li>Aucune donnée personnelle (nom, e-mail, etc.) n'est collectée.</li>
                            <li>Les adresses IP sont anonymisées.</li>
                            <li>Les données ne sont pas utilisées à des fins publicitaires.</li>
                            </ul>
                            <p>Ce traitement minimal des données est réalisé dans le cadre de l'intérêt légitime d'haikara à mieux comprendre la fréquentation du site, sans identifier les visiteurs individuellement. Aucun cookie sur notre site ne requiert le recueil du consentement des internautes.</p>
                            <p style="font-style: italic;">En application de la directive ePrivacy, les internautes doivent être informés et donner leur consentement préalablement au dépôt et à la lecture de certains traceurs, tandis que d'autres sont dispensés. <a href="https://www.cnil.fr/fr/cookies-solutions-pour-les-outils-de-mesure-daudience" target="_blank" style="color: #fff;">En savoir +</a></p>`,
        },
    },
    en: {
        message: {
            yes: "yes",
            no: "no",

            see_all_references: "See all references",

            home: "Home",
            agency: "Agency",
            refs: "Refs",
            technos: "Technos",
            harkhan: "Formavisa",
            lab: "Lab",
            contact: "Contact",
            see_more: "See more",
            our_clients: "Our clients",

            our_news: "Explore our news",

            title_contact: "CONTACT US!",
            btn_devis: "Get a detailed quote",

            contact_content1: "You have a need, let's talk about it!",
            contact_content2: "We can surely help you ...",
            contact_address: "SARL au capital de 200 000 € - SIRET : 48507196300030 - NAF : 5829C",

            title_our_offer: "OUR 100% CUSTOMIZED OFFER",

            title_our_offer_1: "Advice and management of your L&D projects",
            title_our_offer_2: "Digital training and Serious games",
            title_our_offer_3: "Innovation",
            title_our_offer_4: "Videos",
            title_our_offer_5: "Developments",
            title_our_offer_6: "Evaluation and tailor-made LMS",

            desc_our_offer_1: "Definition of your training strategy.<br />Educational and technological advice.<br />Training engineering.",
            desc_our_offer_2: "Immersive games, escape games, storytelling.<br />Storyline 360, RISE, MOOCS, micro-learning.<br />Modules on smartphone. SCORM,xAPI.",
            desc_our_offer_3: "Original approaches, original results.<br />AI solutions, adaptive learning, collaborative modules, memory anchoring, ...",
            desc_our_offer_4: "Interactive films and reports, interviews.<br />Motion design, narrative animations.<br />Teasers.",
            desc_our_offer_5: "Web, mobile applications.<br />PHP, HTML/JS, React Native.<br />AI integration solutions.",
            desc_our_offer_6: "Assessment of knowledge and skills, deployment of training, management of authorizations.",

            btn_our_offer_1: "Understanding our jobs",
            btn_our_offer_2: "Explore our references",
            btn_our_offer_3: "Visit the LAB",
            btn_our_offer_4: "Look at examples",
            btn_our_offer_5: "Learn more",
            btn_our_offer_6: "Discover our solution",

            required_fields: "* Required fields.",

            your_name: "Your name",
            your_name_placeholder: "Your name*",
            your_email: "Votre email",
            your_email_placeholder: "Votre email*",
            your_tel: "Your phone",
            your_request: "Your request, your projects",
            see: "See",

            project_focus_1: "Hot trend",
            intro_project_focus_1: "For Yookan, Haikara develops arcade terminals to introduce professions playing!",

            project_focus_2: "Focus projet",
            intro_project_focus_2: "For Saint-Gobain, Haikara developed a serious game on innovation ... disruptive!",

            project_focus_3: "En direct du lab",
            intro_project_focus_3: "Add unpublished interactions to Storyline?It's possible: an example to test here!",

            project_focus_4: "Focus projet",
            intro_project_focus_4: "With The Great Challenge, Haikara has created an unprecedented serous game of memorization!",

            project_focus_5: "Vidéo",
            intro_project_focus_5: "A Story of Glass is the whole story of the glass from Antiquity to the present day!A video rich in teaching!",

            project_focus_6: "Hot trend",
            intro_project_focus_6: "Quaistion for a champion!With AI, Haikara is launching a free quiz generation service!",

            project_focus_7: "La compil",
            intro_project_focus_7: "Which characters to choose to embody your digital training?Small panorama on video!",

            to_post: "Send",
            msg_footer: "Beautiful day !",
            send_mail_ok: "Your message has been sent successfully",
            send_mail_ko: "An error has occurred, please try again later",
            filter_metier: "#JOB",
            filter_sujet: "#SUBJECT",
            filter_dispositif: "#DEVICE",

            other_refs: "Other topics that may interest you",

            other_extra: "Other topics that may interest you",
            other_functionality: "Other features that may interest you",

            error_has_occurred: "An error has occurred",
            play: "Play",
            restart: "Replay",
            send: "Send",
            game_intro1: "Who am I ?",
            game_intro2: "Which historical figure is behind this AI-generated description?",
            game_pseudo: "Enter your name or nickname",
            game_validate: "To validate",

            devis_intro1: "Would you like to obtain a quote for carrying out your tailor-made digital training?",
            devis_intro2: "<p class='bold'>Yes, I need a price, but I don't have time to write specifications!</p><p>This form is made for you. It will allow us to collect your expectations with sufficient precision to send you a first offer.</p>",
            devis_intro3: "<p class='bold'>What? Why should I fill out such a long form?</p><p>Well there are metrics without which it is difficult to give you a price, such as the duration of the training, the number of languages, or whether to record voices... There are other things that help us, but you don't have to fill them all out!</p>",
            devis_intro4: "<p class='bold'>Ok, but I really don't want to fill out a form...</p><p>We understand. In this case, we can also discuss it by phone or video! Leave a message on <a href='#' class='lk-contact'>the contact page</a>, with your contact details and the subject of your request, and we will call you back as soon as possible.</p>",
            devis_info_required: "means that the field is required",

            devis_label_name: "Your name",
            devis_label_email: "Your email",
            devis_label_tel: "Your phone",

            our_mission: "Our mission",
            our_mission_desc: "Support you in your L&D strategy by tailoring your digital training:<br />effective, memorable and perfectly adapted to your objectives.",
            devis_project: "Let's talk a bit about your project",

            devis_label_title: "Title or subject of training",
            devis_label_duration: "Duration of the user training (in minutes)",
            devis_label_objective: "Training aims",
            devis_label_target: "Target audience (profile, age, knowledge of the computer tool, habit of elearning, etc.)",
            devis_label_modality: "Considered modality (eg linear, non -linear module, cut into micro learning, gamified, etc.)",
            devis_label_number_people_targeted: "Number of people targeted",
            devis_label_delivery_method: "Diffusion mode (s)",
            devis_label_launch_date: "Date of launching your training",
            devis_label_number_of_modules: "If the training contains several modules, you can specify",

            devis_languages_and_sounds: "Languages and sounds",

            devis_language_fr: "French",
            devis_language_en: "English",
            devis_language_other: "Others",

            devis_label_init_lang: "Initial language (model module)",
            devis_label_additional_lang: "Thank you for indicating the number of additional languages",
            devis_label_voiceover: "Voice off and subtitles",
            devis_label_video: "Does the training contain video provided or to be made?",
            devis_label_needs_video: "Please specify the needs (filming, editing, integration)",

            devis_file: "A useful document to send us?",

            devis_label_file_intro: "Useful documents for the quote (tender, specifications, etc.). Please zip the files if there are several. <br /> You can post a single file, in Word, PPT or PDF, from 10 MB maximum. ",
            devis_label_file_btn: "Choose a file",
            devis_label_file_result: "No file chosen",

            devis_technical: "Let's talk a bit technical (or not 🙂)",

            devis_label_technical: "Project technology (if desired) or details (SCORM version, completion mode, quiz with validant score?)",
            devis_label_supports: "Diffusion computer supports (PC, tablets, smartphones?)",
            devis_label_browsers: "Target internet browsers (Chrome, Edge, Firefox ... All?)",
            devis_label_others: "Other useful details",

            devis_production: "What kind of production do you seek?",

            devis_production_opt1: "Level 1: simple linear training",
            devis_production_opt2: "Level 2: scripted and enriched training",
            devis_production_opt3: "Level 3: serious game or equivalent",

            devis_label_level: "Expected level of realization",
            devis_label_accessibility: "Content accessibility",

            devis_accessibility_opt1: "Standard (subtitles for sound projects)",
            devis_accessibility_opt2: "Enriched (keyboard navigation, suitable for non -showing people, ....)",

            devis_label_specific_remarks: "Specific remarks",

            devis_option: "Everything that is follows is good to know, but it is ... Optional!",

            devis_label_atmosphere: "What type of atmosphere are you looking for? (Warm, professional, humorous, corporate, quirky ...)",
            devis_label_graphical_environment: "Do you have a favorite graphic environment? (Video, photos, illustrations, 3D, drawing style, use of characters or not, etc.)",
            devis_label_remark: "One last thing to add?",

            devis_btn: "Send",

            more_ref: "Discover all our references!",

            msg_loader: "<span>haikara</span> offers you a worry-free, cookie-free web experience.",

            fv: {
                banner_1: "A demo?",
                banner_2: "Contact us",
                banner: "Establish and effectively control the evolution <br /> The knowledge of your teams",
                line_1: {
                    text_1: "ASSESSMENT",
                    text_2: "Training",
                    text_3: "Diagnostic",
                    text_4: "Certifying",
                    text_5: "Easily deploy your evaluation sessions to your teams",
                    text_6: "Keep control thanks to exhaustive follow -up and easy to handle.",
                    text_7: "Manage training needs by precisely following the evolution of knowledge over time.",
                    text_8: "Easily create your assessments",
                },
                line_2: {
                    text_1: "habilitation",
                    text_2: "Pilot the authorizations of your teams.",
                    text_3: "Exhaustive traceability of your employees' assessments",
                    text_4: "Response to the most demanding regulatory obligations",
                    text_5: "Accessibility of the results in a few clicks in the event of an audit.",
                    text_6: "An adapted solution <br /> to the most demanding sectors",
                    text_7: "Health, Pharma, Aeronautics, Industry, Medical, Building, Telecom ... <br /> Formavisa was certified Pharma as part of the use of one of its customers.",
                },
                line_3: {
                    text_1: "THEY TRUST US",
                    text_2: "An innovative platform, thought for you, with you",
                    text_3: "Since 2005, our years of constant innovation at the service of all sectors of activity <br /> have enabled us to build a solution that meets your most specific needs <br /> in terms of evaluation andHabilitation. ",
                },
                line_4: {
                    text_1: "Power ≠ complexity",
                    text_2: "Many features available to click that are easy to take in hand!",
                    text_3: "Simply manage <br /> Your base <br /> questions",
                    text_4: "Configuration <br /> and automation <br /> assessments",
                    text_5: "Generate questions <br /> with AI",
                    text_6: "Statistical tool <br /> pushed",
                },
                line_5: {
                    text_1: "AND THAT'S NOT ALL !",
                    text_2: "Formavia is an open adaptive solution <br /> Addition of educational resources of any type <br /> and SCORM compatible.",
                    text_3: "Add educational content, online training and other resources (PPT, PDF, DOC, etc.) or video and go up full routes in addition to your assessments.",
                    text_4: "Combine the conditions of progression in the course with the completion of objectives, or automatically put available to educational content in the event of certification failure, available before the catch -up.",
                    text_5: "Observe the results and draw the proper monitoring of content to meet your training obligations using our statistical monitoring tools.",
                },
                line_6: {
                    text_1: "The Extras",
                    text_2: "A demo?",
                    title_1: "Design of your evaluations",
                    content_1: "Entrust us with your projects!",
                    btn_1: "Haikara accompanies you",
                    title_2: "Elearning compatibility",
                    content_2: "Use your digital training !!",
                    btn_2: "MULTI-FORMAT SESSIONS",
                    title_3: "Personalization and scalability",
                    content_3: "At Haikara our DNA is tailor-made.",
                    btn_3: "YOUR FORMAVISA",
                },
            },

            games: {
                who_is_it: {
                    btn_play: "Play!",
                    content_1: "Let's play with<br />artificial<br />intelligence!",
                    content_2: '<span class="bold">Dialogue with our AI</span> to try to find a historical figure.<br /><span class="bold">Ask him as many questions as you want</span> to achieve it.! ',
                    content_3: "You can also give your language to the chat to discover the answer.",
                    give_me_the_answer: "Give me the answer",
                },
            },

            page_agency: {
                card_01: {
                    title: "<span>CONSULTING</span> <span>AND DESIGN</span>",
                    list: "<li>Definition of the digital training and assessment strategy.</li><li>Analysis of objectives and needs.</li><li>Writing of educational materials.</li>",
                    link: "Learn more about our fundamentals",
                },
                card_02: {
                    title: "<span>CUSTOM-MADE</span> <span>PRODUCTION</span>",
                    list: "<li>Graphic design and production (2D, 3D, illustration, video, etc.).</li><li>Media integration (Storyline, Rise, etc.).</li><li>IT development.</li><li>SCORM 1.2, 2004. xAPI content.</li>",
                    link: "See our references",
                },
                card_03: {
                    title: "<span>DIFFUSION</span> <span>AND EVALUATION</span>",
                    list: "<li>Rental of our FormaVisa platform in SaaS mode.</li><li>Distribution of training content (LMS, LXP).</li><li>Assessment of knowledge and skills.</li>",
                    link: "See the dedicated page",
                },

                intro: '<span class="span_1">SINCE 2005</span>, <span class="span_2">HAIKARA</span> HAS BEEN DESIGNING AND PRODUCING <span class="span_1">ORIGINAL</span> AND <span class="span_1">MEMORABLE</span> <span class="span_1">DIGITAL</span> TRAINING DEVICES.',

                block_1: {
                    title: "haikara brings together all the skills necessary to implement your e-learning training programs.",
                    content: `<p>Teamwork, coordination and communication between the various stakeholders, as well as smooth production, are the foundations that ensure deadlines are met
                            with a constant demand for quality.</p>
                            <p>We support you throughout all stages of implementing e-learning training: choosing the program, defining the training program, implementation, and communication and incentive activities.</p>`,
                },
                block_2: {
                    title: "We provide advice and expertise to design materials that meet the training and assessment needs of companies.",
                    content: `<p>Our productions are scripted and presented to promote immersion
                            and motivation among learners, with the goal of facilitating learning
                            and developing their skills.</p>`,
                },
                block_3: {
                    title: "We are involved in all phases of your projects.",
                    content: `<p>Choice of training programs, design
                        and production of materials, implementation
                        of our assessment and certification solution, deployment on LMS, and communication plan.</p>`,
                },
            },

            share_this_reference: "Share this reference",
            link_copied: "Link copied!",
            copy_link: "Copy link",
            share_close: "Close",

            footer_cookie: "Our site does not process any personal data. <span class='clickable-cookie' data-action='cookie-more'>Learn more</span> about our strict policy regarding the protection of your privacy.",
            content_cookie: `<p>We use <strong>Google Analytics 4</strong> solely for audience measurement purposes on our site, without collecting personally identifiable data.</p>
                                <ul>
                                <li>No personal data (name, email, etc.) is collected.</li>
                                <li>IP addresses are anonymized.</li>
                                <li>The data is not used for advertising purposes.</li>
                                </ul>
                                <p>This minimal data processing is carried out within the framework of Haikara's legitimate interest in better understanding site traffic, without identifying individual visitors. No cookies on our site require user consent.</p>
                                <p style="font-style: italic;">In accordance with the ePrivacy Directive, Internet users must be informed and give their consent prior to the installation and reading of certain trackers, while others are exempt. <a href="https://www.cnil.fr/fr/cookies-solutions-pour-les-outils-de-mesure-daudience" target="_blank" style="color: #fff;">Learn more</a></p>`,
        },
    },
};

export default messages;
